import React from 'react';
import classnames from 'classnames';
import SVGInline from 'react-svg-inline';

import IconWarn from 'icons/actions/warning.svg';
import styles from './Banner.scss';

export default function Banner({ children, type }) {
  return (
    <div className={classnames(styles.banner, styles[type])}>
      <SVGInline svg={IconWarn} width="16px" className={styles.icon} />
      {children}
    </div>
  );
}

Banner.propTypes = {
  type: React.PropTypes.oneOf(['warn', 'error']),
  children: React.PropTypes.any,
};

Banner.defaultProps = { type: 'warn' };



// WEBPACK FOOTER //
// ./src/components/alerts/components/Banner.jsx